import Form from "./Form";

class GroupForm extends Form {
  constructor(form) {
    super(form);
    this.type = "group";
  }

  getData() {
    const data = new FormData();
    const f = this.form;

    data.set("post_id", this.post_id);
    data.set("company", f.company.value);
    data.set("contact_person", f.contact_person.value);
    data.set("email", f.email.value);
    data.set("payment_method", f.payment_method.value);
    data.set("phone", f.phone.value);
    data.set("file", f.file.files[0]);
    data.set("disclaimer", f.disclaimer.checked ? 1 : 0);

    return data;
  }
}

export default GroupForm;
